import HttpClient from "../../HttpClient.ts";
import apiRoutes from "../../Routes/Routes.json";

const GetIDRacksLookup = () => {
  return HttpClient().get(
    `/${apiRoutes.InfectiousDisease.GetIDLISRackDetails_Lookup}`
  );
};

const SaveRackCreation = (queryModel) => {
  return HttpClient().post(
    `/${apiRoutes.InfectiousDisease.IDLISCreateExtraction_AddNewRack}`,
    queryModel
  );
};

const GetRackPlateDetailsById = (RackDetailId) => {
  return HttpClient().post(
    `/${apiRoutes.InfectiousDisease.IDLISCreateExtraction_GetRackPlateDetailsById}/${RackDetailId}`
  );
};

const SaveRackPlateDetails = (queryModel) => {
  return HttpClient().post(
    `/${apiRoutes.InfectiousDisease.IDLISCreateExtraction_SaveRackPlateDetails}`,
    queryModel
  );
};

const GetExtractionRacksScanningLogs = (obj) => {
  return HttpClient().post(
    `/${apiRoutes.InfectiousDisease.GetExtractionRacksScanningLog}`,
    obj
  );
};

const ExportRackPlateDetailsById = (RackDetailId) => {
  return HttpClient().post(
    `/${apiRoutes.InfectiousDisease.ExportRackPlateDetailsById}/${RackDetailId}`
  );
};

const UpdateRackPlateAccession = (payload) => {
  return HttpClient().post(
    `/${apiRoutes.InfectiousDisease.IDLISCreateExtraction_UpdateRackPlateAccession}`,
    payload
  );
};

const CreateExtractionService = {
  GetIDRacksLookup,
  SaveRackCreation,
  GetRackPlateDetailsById,
  SaveRackPlateDetails,
  GetExtractionRacksScanningLogs,
  ExportRackPlateDetailsById,
  UpdateRackPlateAccession,
};

export default CreateExtractionService;
